/** Délai sans interaction avant masquage de l’indicateur (pad déconnecté ou inactif). */
export const LYRRA_ACCESS_PAD_IDLE_MS = 5 * 60 * 1000;

/** Fenêtre pour détecter un double appui F13 (quitter le mode LyrraPad). */
export const LYRRA_ACCESS_PAD_F13_DOUBLE_MS = 450;

/** Touches émises par le Lyrra Access Pad (navigation / validation). */
export const LYRRA_ACCESS_PAD_ACTIVITY_KEYS = new Set([
  ' ',
  'ArrowRight',
  'ArrowLeft',
  'Enter',
  'r',
  'R',
  'Escape',
]);

/** F13 = signal de connexion / appairage du clavier adapté Lyrra. */
export function isLyrraAccessPadF13(event: KeyboardEvent): boolean {
  return event.key === 'F13' || event.code === 'F13';
}

export function isLyrraAccessPadActivityKey(event: KeyboardEvent): boolean {
  if (isLyrraAccessPadF13(event)) return true;
  return LYRRA_ACCESS_PAD_ACTIVITY_KEYS.has(event.key);
}

export const LYRRA_ACCESS_PAD_CONNECTED_EVENT = 'lyrra-access-pad-connected';
export const LYRRA_ACCESS_PAD_DISCONNECTED_EVENT = 'lyrra-access-pad-disconnected';
/** F13 alors que le badge est déjà affiché → lecture / pause du guide vocal. */
export const LYRRA_ACCESS_PAD_F13_TOGGLE_GUIDE_EVENT = 'lyrra-access-pad-f13-toggle-guide';
